import { Injectable } from '@angular/core';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class MigrationsService extends UserService {

    constructor(
        protected requestService: RequestService,
        protected auth: Auth
    ) { super(requestService, auth); }

    protected getUsersUrl(): string {

        return 'migration';
    };

    protected getOneUserUrl(): string {

        return 'migration';
    };

    protected parseObject(obj: any): any {

        return obj as any;
    };

    protected parseArray(objs: any): any[] {

        return objs as any[];
    };

    get(): Promise<any[]> {

        return this.requestService.makeRequest({
            urlKey: "migration",
        })
            .then((response: any) => this.parseArray(response.json()));
    };

}



// WEBPACK FOOTER //
// ./src/app/services/migrations/migrations.service.ts